<template>
  <div class="privacy-page__content">
    <header class="terms__header">
      <h2>{{ $t("footer.privacy") }}</h2>
    </header>

    <privacy-policy-text></privacy-policy-text>
  </div>
</template>

<script>
export default {
  name: "Privacy",
};
</script>

<style lang="sass">
.privacy-page__content
  width: 100%
  text-align: left
  padding: 20px
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  background: #FFFFFF

  .terms__header
    width: 100%
    max-width: 700px
    margin: 0 auto

  .terms__content
    max-width: 700px

    h1, h2, h3, h6, p, ul, ol
      margin: revert

      li
        margin: inherit
</style>
